import { render, staticRenderFns } from "./ComplexEditorView.vue?vue&type=template&id=639b7582&"
import script from "./ComplexEditorView.vue?vue&type=script&lang=js&"
export * from "./ComplexEditorView.vue?vue&type=script&lang=js&"
import style0 from "./ComplexEditorView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639b7582')) {
      api.createRecord('639b7582', component.options)
    } else {
      api.reload('639b7582', component.options)
    }
    module.hot.accept("./ComplexEditorView.vue?vue&type=template&id=639b7582&", function () {
      api.rerender('639b7582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ComplexEditorView.vue"
export default component.exports